<template>
    <div class="common-width common-height warp-index">
        <BlockTop></BlockTop>
        <div class="common-flex">
           <div :style='{width:(this.$store.state.leftBlockWidth)+"px",height:(this.$store.state.windowHeight-this.$store.state.topBlockHeight)+"px"}'>
               <BlockLeft/>
           </div>
           <div :style='{width:(this.$store.state.windowwidth-this.$store.state.leftBlockWidth)+"px",height:(this.$store.state.windowHeight-this.$store.state.topBlockHeight)+"px",padding:this.$store.state.indexPadding+"px",boxSizing:"border-box"}'>
               <BlockNav/>
               <BlockRou/>
           </div>
        </div> 
    </div>
</template>
<script>
  import BlockTop  from '../components/component-Brow/block-top.vue';
  import BlockLeft from '../components/component-Brow/block-let.vue';
  import BlockNav  from '../components/component-Brow/block-nav.vue'; 
  import BlockRou  from '../components/component-Brow/block-router.vue' 
  export default{
     components:{
        BlockTop,
        BlockLeft,
        BlockNav,
        BlockRou
     }
  }
</script>
<style lang="scss" scoped>
   .warp-index{
      background-size: cover;
      background-image:url("./../assets/custom-image/indexBack.svg");
      background-repeat: no-repeat;  
   }
</style>